import React from 'react';
//import css from './css.less';
import { Image as OriImage } from 'antd';
const Image = (props) => {
  const { ...rest } = props;
  return <OriImage {...rest} />;
};
export default Image;
